// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"styles_sectionWrapper__GelxD","wrapper":"styles_wrapper__OTG5U","aboutMe":"styles_aboutMe__aDks7","var1":"styles_var1__yS63q","var2":"styles_var2__BG0Ks"};